function initSearchWithEnter() {
  $('form[role="search"]').on('keypress',function(e) {
    if(e.target.tagName === 'input' && e.which == 13) {
      $(this).find('button[type="submit"], input[type="submit"]').trigger('click');
    }
  });
}
